module.exports = __webpack_public_path__ + "img/invoice-ch-male-banner.0bdd13c6.png";